import { logger } from '@/lib/client'

declare const dataLayer: unknown[]

export const AdversetimentServerLoader = async (
  ads: Array<{
    position: string
    tag: string
    advertiser: string
    target: string
    img_xs: {
      url: string
      width: number
      height: number
    }
    img_lg: {
      url: string
      width: number
      height: number
    }
    link: string
  }>,
): Promise<void> => {
  const event = 'Carregar anúncios'

  try {
    if (dataLayer) {
      for (const ad of ads) {
        dataLayer.push({
          event: 'ad-server-loader',
          ad,
        })
      }
    }
  } catch (error) {
    logger(
      'TRACKING ADS LOADER',
      JSON.stringify({
        event: event,
        name: error?.name,
        message: error?.message,
      }),
    )
  }
}
